import { createReducer } from "typesafe-actions";

import EmailStatus from "@mapmycustomers/shared/enum/EmailStatus";
import SortOrder from "@mapmycustomers/shared/enum/SortOrder";
import Email from "@mapmycustomers/shared/types/email/Email";

import EmailOutboxTab from "../enums/EmailOutboxTab";

import {
  Actions,
  fetchOutboxEmails,
  fetchOutboxStatusCounts,
  setOutboxActiveTab,
  setOutboxPage,
  setOutboxSearch,
  setOutboxSort,
} from "./actions";
import SortState from "./SortState";

const DEFAULT_SORT: SortState = { fieldName: "date", order: SortOrder.DESC };

export interface EmailOutboxViewState {
  page: number;
  search: string;
  sort: SortState;
  total: number;
}

export interface EmailOutboxState {
  activeTab: EmailOutboxTab;
  emails: Email[];
  loading: boolean;
  statusCounts: Record<EmailStatus, number>;
  viewState: EmailOutboxViewState;
}

const initialViewState: EmailOutboxViewState = {
  page: 1,
  search: "",
  sort: DEFAULT_SORT,
  total: 0,
};

const initialState: EmailOutboxState = {
  activeTab: EmailOutboxTab.OUTGOING,
  emails: [],
  loading: false,
  statusCounts: {
    [EmailStatus.CANCELLED]: 0,
    [EmailStatus.ERRORED]: 0,
    [EmailStatus.SCHEDULED]: 0,
    [EmailStatus.SENDING]: 0,
    [EmailStatus.SENT]: 0,
    [EmailStatus.SUBMITTED]: 0,
  },
  viewState: initialViewState,
};

const emailOutbox = createReducer<EmailOutboxState, Actions>(initialState)
  .handleAction(fetchOutboxEmails.request, (state) => ({
    ...state,
    emails: [],
    loading: true,
  }))
  .handleAction(fetchOutboxEmails.success, (state, { payload: { emails, total } }) => ({
    ...state,
    emails,
    loading: false,
    viewState: { ...state.viewState, total },
  }))
  .handleAction(fetchOutboxEmails.failure, (state) => ({
    ...state,
    emails: [],
    loading: false,
    viewState: { ...state.viewState, total: 0 },
  }))
  .handleAction(fetchOutboxStatusCounts.success, (state, { payload }) => ({
    ...state,
    statusCounts: payload,
  }))
  .handleAction(setOutboxActiveTab, (state, { payload }) => ({
    ...state,
    activeTab: payload,
    viewState: initialViewState,
  }))
  .handleAction(setOutboxPage, (state, { payload }) => ({
    ...state,
    viewState: { ...state.viewState, page: payload },
  }))
  .handleAction(setOutboxSearch, (state, { payload }) => ({
    ...state,
    viewState: { ...state.viewState, page: 1, search: payload },
  }))
  .handleAction(setOutboxSort, (state, { payload }) => ({
    ...state,
    viewState: { ...state.viewState, page: 1, sort: payload },
  }));

export * from "./selectors";
export type EmailOutboxActions = Actions;
export default emailOutbox;
